var map = {
	"./sfx_animal_chameleon.mp3": 324,
	"./sfx_animal_elephant.mp3": 325,
	"./sfx_animal_flamingo.mp3": 326,
	"./sfx_animal_giraffe.mp3": 327,
	"./sfx_animal_koala.mp3": 328,
	"./sfx_animal_lion.mp3": 329,
	"./sfx_animal_monkey_01.mp3": 330,
	"./sfx_animal_monkey_02.mp3": 331,
	"./sfx_animal_tiger.mp3": 332,
	"./sfx_animal_zebra.mp3": 333
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;